import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import InputSelectButtonComponent from '../../components/inputs/InputSelectButtonComponent';
import DivContainer from '../../components/DivContainer';
import {FileUpload} from 'primereact';
import FileUploadService from '../../services/FileUploadService';
import AvatarService from '../../services/AvatarService';
import Constants from '../../utils/constants';

class AvatarUploadDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new FileUploadService());
        this.state = {
            selectedFile: undefined,
            choosenType: undefined,
            uploadedFile: undefined,
            avatarTypes: [
                {
                    label: t('avatarTypes.GROUP'),
                    enumValue: 'GROUP',
                },
                {
                    label: t('avatarTypes.USER'),
                    enumValue: 'USER',
                },
            ],
        };
        this.avatarService = new AvatarService();
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    onSelect = (e) => {
        this.setState(
            {
                selectedFile: e.files[0],
            },
            () => {
                this.uploadHandler();
            }
        );
    };

    onClear = () => {
        this.setState({
            selectedFile: undefined,
        });
    };

    uploadHandler = async () => {
        const selectedFile = this.state.selectedFile;
        const formData = new FormData();
        formData.append('file', selectedFile);
        this.service.uploadAttachemnt(formData).then((uploadedFile) => {
                this.setState({uploadedFile});
        }).catch((err) => {
                this.showErrorMessage(t('message.tooLargeFileSize'));
        
            });
    };

    saveAvatar = () => {
        const choosenType = this.state.choosenType;
        const uuid = this.state.uploadedFile?.uuid;
        if (choosenType?.enumValue) {
            if (choosenType.enumValue === 'GROUP') {
                this.avatarService.addDefaultGroupAvatar(uuid).then(() => {
                    this.props.afterSave();
                });
            } else {
                this.avatarService.addDefaultUserAvatar(uuid).then(() => {
                    this.props.afterSave();
                });
            }
        } else {
            this.showErrorMessage(t('error.noneAvatarTypeSelected'));
        }
    };

    prepareFooterItems() {
        return [];
    }

    renderHeader() {
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>{t('avatar.addHeader')}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    getContainerListName() {
        return 'avatar-list-container';
    }

    renderDetails() {
        return (
            <div className='row'>
                <InputSelectButtonComponent
                    id='choosenType'
                    name='choosenType'
                    colClass='col-md-6'
                    value={this.state.choosenType}
                    options={this.state.avatarTypes}
                    optionLabel='label'
                    onChange={this.handleChange}
                    viewMode={this.props.viewMode}
                    validator={this.props.validator}
                    stateField=''
                    validators='required'
                    validateViewMode
                />
                <FileUpload
                    uploadLabel={t('file.upload')}
                    chooseLabel={t('file.choose')}
                    cancelLabel={t('file.cancel')}
                    multiple={false}
                    customUpload
                    onSelect={this.onSelect}
                    onRemove={this.onClear}
                    onClear={this.onClear}
                    uploadHandler={this.saveAvatar}
                    accept='*'
                    maxFileSize = {this.props.imgMaxSizeParameter}
                    invalidFileSizeMessageSummary = {t('global.invalidFileSizeSummary')} 
                    invalidFileSizeMessageDetail =  {t('global.invalidFileSizeDetails') + this.props.fileSizeToTranslation}
                />
            </div>
        );
    }
}

AvatarUploadDialog.defaultProps = {
    currentUser: undefined,
    visible: false,
    stationId: undefined,
    changePackageUrl: '/change-package',
};

AvatarUploadDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    changePackageUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
};

export default withTranslation()(AvatarUploadDialog);
